import styles from "components/cards/palette/PostOptionCard.module.scss";
import Image from "next/image";
import classNames from "classnames";
import utilStyles from "styles/utils.module.scss";
import ProductScrapButton from "components/buttons/ProductScrapButton";
import ScrapIconActive from "images/icons/heart_fill.svg";
import InactiveScrapShadowIcon from "images/icons/heart_line.svg";
import TruncateMarkup from "react-truncate-markup";
import PipeIcon from "images/icons/pipe.svg";
import {toast} from "react-toastify";
import {formattedPrice, numberWithComma} from "common/utils";
import useTranslation from "next-translate/useTranslation";


const PostOptionCard = (props) => {
    const {postId, productOption, itemIdx, handleOptionClick} = props;
    const {t} = useTranslation('components-cards-palette-PostOptionCard');

    const onOptionClick = () => {
        typeof mixpanel !== 'undefined' && mixpanel.track(
            'PostOptionCardClick',
            {
                optionId: productOption.id,
                postId: postId,
                itemIdx
            }
        );
        if (productOption.is_entered) {
            if (handleOptionClick) {
                handleOptionClick(productOption, itemIdx);
            }
        }
        else {
            toast.info(t('PostOptionCard.notEnteredProduct')); // TODO: Use toast
        }
    };

    const priceText = productOption.is_entered ? formattedPrice(productOption.discounted_price, productOption.currency) : t('PostOptionCard.notEntered');

    return (
        <div className={styles.optionContainer} onClick={onOptionClick}>
            <div className={styles.optionImageWrapper}>
                <Image unoptimized layout="fill" objectFit="cover" src={productOption.image_url} />
            </div>
            <div className={styles.optionInfoSection}>
                <div className={classNames(utilStyles.justifyContentSpaceBetween, utilStyles.flexRow, utilStyles.alignItemsCenter, styles.optionBrandWrapper)}>
                    <span className={classNames(styles.optionBrandName, !productOption.is_entered && styles.notEnteredItem)}>{productOption.brand_name}</span>
                </div>
                <TruncateMarkup lines={1} ellipsis={<span className={styles.optionName}>...</span>}>
                    <div>
                        <span className={classNames(styles.optionName, !productOption.is_entered && styles.notEnteredItem)}>{productOption.name}</span>
                        {
                            productOption.product_name &&
                            <>
                                <TruncateMarkup.Atom>
                                    <PipeIcon viewBox="0 0 16 16" className={styles.pipe} />
                                </TruncateMarkup.Atom>
                                <span className={classNames(styles.optionName, !productOption.is_entered && styles.notEnteredItem, utilStyles.fullFlex)}>{productOption.product_name}</span>
                            </>
                        }
                    </div>
                </TruncateMarkup>
                <span className={classNames(styles.optionPrice, !productOption.is_entered && styles.notEntered)}>{priceText}</span>
            </div>
            <div className={styles.scrapButtonContainer}>
            {
                productOption.is_entered ?
                    <ProductScrapButton
                        productId={productOption.product_id}
                        renderScrapped={() => <ScrapIconActive viewBox="0 0 24 24" width={20} height={20} />}
                        renderUnscrapped={() => <InactiveScrapShadowIcon viewBox="0 0 24 24" width={20} height={20} />}
                    />
                    :
                    <div style={{height: 20, width: 20}} />
            }
            </div>
        </div>
    )

};

export default PostOptionCard;
